
// Google Analytics 4 integration service
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

export const initializeGA = (measurementId: string) => {
  console.log('Initializing Google Analytics with ID:', measurementId);
  
  // Remove existing GA script if present
  const existingScript = document.querySelector(`script[src*="gtag/js?id=${measurementId}"]`);
  if (existingScript) {
    console.log('Removing existing GA script');
    existingScript.remove();
  }

  // Create the gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.onload = () => {
    console.log('Google Analytics script loaded successfully');
  };
  script.onerror = () => {
    console.error('Failed to load Google Analytics script');
  };
  document.head.appendChild(script);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    console.log('gtag called with arguments:', arguments);
    window.dataLayer.push(arguments);
  };

  // Configure GA
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    page_title: document.title,
    page_location: window.location.href,
  });

  console.log('Google Analytics initialized');
};

export const trackPageView = (page: string, title?: string) => {
  const measurementId = getStoredMeasurementId();
  if (typeof window.gtag !== 'undefined' && measurementId) {
    console.log('Tracking page view:', page, title);
    window.gtag('config', measurementId, {
      page_path: page,
      page_title: title || document.title,
    });
  } else {
    console.log('gtag not available or no measurement ID for page tracking');
  }
};

export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window.gtag !== 'undefined') {
    console.log('Tracking event:', { action, category, label, value });
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  } else {
    console.log('gtag not available for event tracking');
  }
};

// Storage functions for measurement ID
export const storeMeasurementId = (measurementId: string) => {
  console.log('Storing measurement ID:', measurementId);
  localStorage.setItem('ga_measurement_id', measurementId);
};

export const getStoredMeasurementId = (): string | null => {
  const stored = localStorage.getItem('ga_measurement_id');
  console.log('Retrieved stored measurement ID:', stored);
  return stored;
};

export const removeMeasurementId = () => {
  console.log('Removing measurement ID from storage');
  localStorage.removeItem('ga_measurement_id');
};
